import { ReactNode } from 'react';

import { ErrorReason } from './ErrorScreen.types';

export interface AppErrorCause {
  reason?: ErrorReason;
  title?: ReactNode;
  description?: ReactNode;
}

export class AppError extends Error {
  constructor(cause?: AppErrorCause) {
    super(`Application error occured: ${JSON.stringify(cause)}`, { cause });
  }
}

export function throwAppError(cause?: AppErrorCause) {
  throw new AppError(cause);
}
